import View from './View.js';
import previewView from './previewView.js';
import { icons } from '../../img/icons.svg';

class resultsView extends View{
    _parentEl = document.querySelector('.results');
    _errorMes = 'No recipe was found for your search';
    _message ='';
    _generateMarkup(){
      return this._data.map(result => previewView.render(result, false)).join('')
  }
    
}

export default new resultsView();